import { connect } from 'dva';
import IncubatorDetailServer from '../../../components/Incubator/IncubatorDetailServer';

const mapStateToProps = (state) => {
  return{
    parkId:15,
    parkBaseInfoVO:state.incubatordetailServer.parkBaseInfoVO,
    parkExtInfoVO:state.incubatordetailServer.parkExtInfoVO,
    parkMediaExtInfoVOList:state.incubatordetailServer.parkMediaExtInfoVOList
  };
};
const mapDispatchToProps = (dispatch) => ({
  // 获取详情数据
  queryParkInfo:(parkId) =>{
    dispatch({type:'incubatordetailServer/queryParkInfo',parkId});
  }
});

export default connect(mapStateToProps,mapDispatchToProps)(IncubatorDetailServer);


// WEBPACK FOOTER //
// ./src/scripts/containers/Incubator/IncubatorDetailServer/index.js